import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
// QUERY
import { queryClient } from "@config/tanstack/tanstackQuery";
import { retrievePlayerQueryOpts } from "src/services/apiQueries/players";

export const Route = createFileRoute("/_authenticated/app/players/$playerId")({
  component: Outlet,
  loader: async (ctx) => {
    const playerId = parseInt(ctx.params.playerId);
    if (isNaN(playerId)) {
      throw notFound();
    }
    return await queryClient.ensureQueryData(retrievePlayerQueryOpts(playerId));
  },
});
